<template>
  <div v-if="visible">
    <div class="dialog_box">
      <div style="display: flex; justify-content: space-between;">
        <div class="dialog_box_txt">分销者数据详情</div>
        <img @click="handleClose" class="dialog_box_img" src="../../../../assets/dele.png" alt="">
      </div>
      <template>
        <div v-if="visible">
          <div class="dialog_box">
            <div style="display: flex; justify-content: space-between;">
              <div class="dialog_box_txt">分销者数据详情</div>
              <img @click="handleClose" class="dialog_box_img" src="../../../../assets/dele.png" alt="">
            </div>
            <div style="display: flex; justify-content: space-between;" class="m_30_40">
              <div style="display: flex;">
              </div>
              <div style="display:flex;gap: 20px;">
                <div class="time_box">
                  <el-date-picker class="separator_time" v-model="pickerTime" type="daterange"
                                  @change="pickerTime_change"
                                  range-separator="~" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  :clearable="false"
                  >
                  </el-date-picker>
                </div>

                <div class="user_box">
                <el-select v-model="value" placeholder="请选择人员" filterable @change="fxz_change" clearable>
                  <el-option
                      v-for="item in fxzList"
                      :key="item.user_no"
                      :label="item.nickname"
                      :value="item.user_no">
                  </el-option>
                </el-select>
                </div>
              </div>
            </div>
            <el-table :header-cell-style="tableHeaderStyle" :data="tabledata.list" style="width: 100%">
              <el-table-column prop="institution_partner_name" label="招商人员">
              </el-table-column>
              <el-table-column prop="count_audited_success" label="申样审核数(个)">
              </el-table-column>
              <el-table-column prop="count_express_success" label="申样发货数(个)">
              </el-table-column>
              <el-table-column prop="count_product_audited" label="商品审核数(个)">
              </el-table-column>
            </el-table>
            <div style="display: flex; justify-content: center;" class="m_t_38">
              <el-pagination background layout="prev, pager, next" :total="tabledata.total"
                             :page-size="tabledata.per_page" :current-page="tabledata.current_page"
                             @current-change="handlePageChange"></el-pagination>
            </div>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import * as Ajax from '@/api/fxz';
import {fxzList} from "../../../../api/fxz";

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    detail: {
      type: Object,
    },
    form: {
      type: Object,
      default: {}
    },
    pageCg: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
      tableHeaderStyle() {
        return 'color:#fff; background: #045079;';
      },
      pickerTime: [],
      tabledata: {},
      // visible: false

      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      fxzList:[],
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.pickerTime = [this.form.fx_user_date_start, this.form.fx_user_date_end]
      } else {
        this.pickerTime = []
      }
    },
    detail(newVal) {
      this.tabledata = newVal
    }
  },
  created() {
    Ajax.fxzList().then(res=>{
      this.fxzList=res.data
    })
  },
  methods: {
    pickerTime_change() {
      this.$parent.dialogTimeCg(this.pickerTime[0], this.pickerTime[1])
    },
    fxz_change(userId){
      this.$parent.dialogFxzCg(userId)
    },
    handleClose() {
      this.$emit('close');
    },
    handlePageChange(page) {
      this.$parent.dialogPageCg(page)
    }
  }
}
</script>

<style lang="scss" scoped>

.dialog_box {
  padding: 30px 40px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: calc(100% - 80px);
  height: calc(100vh - 148px);
  background-image: url(../../../../assets/aialog.png);
  background-size: 100% calc(100vh - 88px);
}

.dialog_box_img {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.dialog_box_txt {
  font-weight: 600;
  font-size: 26px;
  color: #FFFFFF;

}

::v-deep .el-table__header {

  background-color: #122b4a !important;
  color: #00D2FF !important;
}

::v-deep .el-table {

  background-color: #122b4a !important;
  color: #00D2FF !important;
}

::v-deep tr {

  background-color: #122b4a !important;
  color: #00D2FF !important;
}

::v-deep .el-table__row {
  height: 60px;
  line-height: 60px;
  border-color: #122b4a !important;
}

::v-deep .el-table__cell {
  height: 40px;
  line-height: 40px;
  border-color: rgba(255, 255, 255, .14) !important;
}

::v-deep.colgroup {
  background-color: red;
}

::v-deep .btn-prev {
  background: rgba(255, 255, 255, 0.14) !important;
  border: 1px solid #00A8FF !important;
  color: #00A8FF !important;
}

::v-deep .btn-next {
  background: rgba(255, 255, 255, 0.14) !important;
  color: #00A8FF !important;
  border: 1px solid #00A8FF !important;
}

::v-deep .number {
  background: rgba(255, 255, 255, 0.14) !important;
  border: 1px solid #00A8FF !important;
  color: #00A8FF !important;
}

::v-deep .number.active {
  background: #01aaff !important;
  border: 1px solid #01aaff !important;
  color: white !important;
}

::v-deep .el-select .el-input.is-focus .el-input__inner{
  border: 1px solid #045e82 !important;
  color: #00A8FF !important;
}

//::v-deep el-input__inner{
//  background: rgba(255, 255, 255, 0.14) !important;
//  border: 1px solid #00A8FF !important;
//  color: #00A8FF !important;
//}


.separator_time {
  padding: 0;
  margin: 0;
  height: 40px;
  width: 462px;
  background: #045e82 !important;
  line-height: 40px;
  background-size: 462px 40px;
  color: #00D2FF;
}

::v-deep .el-range-input {
  color: #00A8FF !important;
  background: #045e82 !important;
}

::v-deep .el-range-separator {
  color: #00A8FF !important;
  background: #045e82 !important;
}

::v-deep .el-input__inner {
  border: 1px solid #285d7f;
}

::v-deep .el-input__inner:hover {
  border: 1px solid #045e82 !important;
}

::v-deep .el-input__inner:focus {
  border: 1px solid #045e82 !important;
}

::v-deep .el-range-editor.is-active {
  border: 1px solid #045e82 !important;
}

::v-deep .el-select:hover .el-input__inner {
  border: 1px solid #045e82 !important;
}

::v-deep .el-input__icon {
  color: #00A8FF !important;
}

::v-deep .el-select .el-input__inner{
  background: #045e82 !important;
  color: #00A8FF !important;
}
::v-deep .el-select .el-input__inner::placeholder{
  color: #00A8FF !important;
}



.time_box {
  width: 360px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(../../../../assets/login_input.png);
  background-size: 360px 40px;
  background-repeat: no-repeat;
}

.user_box{
  width: 230px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(../../../../assets/login_input.png);
  background-size: 230px 40px;
  background-repeat: no-repeat;
}


.m_t_38 {
  margin-top: 38px;
}

.flex_box {
  margin-right: 70px;
  display: flex;
}

.flex_box_dian {

  width: 8px;
  height: 8px;
  background: #FFFFFF;
  border-radius: 50%;
  opacity: 0.6;
  margin-top: 7px;
  margin-right: 9px;
}

.flex_box_txt {
  line-height: 22px;
  font-weight: 400;
  font-size: 22px;
  color: #00D2FF;
}

.m_30_40 {
  margin-top: 30px;
  margin-block: 40px;
}
</style>